function formatSections<T>(
  sections: {title: string; attrName: keyof T}[],
  obj: T,
  updated: boolean,
  customFormatter?: (value: T[keyof T]) => string,
): string {
  const messages = [];

  messages.push(
    ...sections.map((section) =>
      _formatSection(obj, section.attrName, section.title, updated, customFormatter),
    ),
  );

  return messages.join('\n\n');
}

function _formatSection<T>(
  obj: T,
  attrName: keyof T,
  title: string,
  updated: boolean,
  customFormatter?: (value: T[keyof T]) => string,
): string {
  const value = obj[attrName];
  const formatter =
    customFormatter || ((val: T[keyof T]) => (val ? JSON.stringify(val, null, 2) : '(empty)'));

  return `${title}${updated ? ' Updated:' : ':'}\n${formatter(value)}`;
}

export default formatSections;
